module.exports = __webpack_public_path__ + "static/media/empty_picture.3f8b41e2.png";